import { ColumnsType } from 'antd/es/table'
import { Table } from 'antd/lib'
import { t } from 'i18next'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { styled } from 'styled-components'
import { SectionLoadingState } from '../../../../components'
import { NO_DATA_PLACEHOLDER } from '../../../../constants/constants'
import { useAlgorithmRunDetails } from '../../../../hooks'
import {
  FlowCytometryNodeResult,
  FlowCytometryReviewAnalysisRunResult,
  ReviewAnalysisAdditionalFileReviewRow,
} from '../../../../store/reducers/workspaceReducer'
import { SmartFunctionListPanelLayout } from '../../components/SmartFunctionListPanelLayout'

const SectionLoadingStateContainer = styled.div`
  display: flex;
  height: calc(100vh - 224px);
`

interface ExtendedReviewAnalysisAdditionalFileReviewRow extends ReviewAnalysisAdditionalFileReviewRow {
  key: string
}

const FlowCytometryReviewAnalysisAdditionalAnalysisFileReviewPanel = () => {
  const { workspaceId, algorithmRunId } = useParams()

  const { loading, selectedAlgorithmRun } = useAlgorithmRunDetails({
    workspaceId,
    algorithmRunId,
    preventFetch: true,
  })

  const nodeResults = useMemo(
    () =>
      selectedAlgorithmRun?.nodeResults
        ? ((selectedAlgorithmRun?.nodeResults as FlowCytometryNodeResult)
            ?.REVIEW_ANALYSIS as FlowCytometryReviewAnalysisRunResult)
        : undefined,
    [selectedAlgorithmRun],
  )

  const formattedData: ExtendedReviewAnalysisAdditionalFileReviewRow[] =
    useMemo(
      () =>
        nodeResults && nodeResults.additionalFileReview
          ? nodeResults.additionalFileReview.map(
              (file: ReviewAnalysisAdditionalFileReviewRow, dataIndex) =>
                ({
                  ...file,
                  key: `${file.attachmentName}-${dataIndex}`,
                }) as ExtendedReviewAnalysisAdditionalFileReviewRow,
            )
          : [],
      [nodeResults],
    )

  // const formattedData: ExtendedReviewAnalysisAdditionalFileReviewRow[] = [
  //   {
  //     key: '1',
  //     attachmentName: 'Attachment name hard coded',
  //     checkType: 'Check type hard coded',
  //     flagMessage:
  //       'Polygon bounding box differs on both X and Y axes by more than 5.0%.',
  //   },
  // ]

  const columns: ColumnsType<ReviewAnalysisAdditionalFileReviewRow> = useMemo(
    () => [
      {
        title: t(
          'smartFunctionDetailsPage.cellCartaFlowCytometryReviewAnalysis.tableTitles.attachmentName',
        ),
        dataIndex: 'attachmentName',
        key: 'attachmentName',
        width: '33%',
        render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
      },
      {
        title: t(
          'smartFunctionDetailsPage.cellCartaFlowCytometryReviewAnalysis.tableTitles.checkType',
        ),
        dataIndex: 'checkType',
        key: 'checkType',
        width: '33%',
        render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
      },
      {
        title: t(
          'smartFunctionDetailsPage.cellCartaFlowCytometryReviewAnalysis.tableTitles.flagMessage',
        ),
        dataIndex: 'flagMessage',
        key: 'flagMessage',
        width: '34%',
        render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
      },
    ],
    [],
  )

  return loading ? (
    <SectionLoadingStateContainer>
      <SectionLoadingState />
    </SectionLoadingStateContainer>
  ) : (
    <SmartFunctionListPanelLayout>
      <Table
        columns={columns}
        dataSource={formattedData}
        loading={loading}
        rowKey="key"
        pagination={false}
        scroll={{ y: 'calc(100vh - 190px)' }}
        rowClassName="page-list-table-row"
      />
    </SmartFunctionListPanelLayout>
  )
}

export default FlowCytometryReviewAnalysisAdditionalAnalysisFileReviewPanel
